var render = function () {
  var _vm$user, _ref, _ref$format, _vm$user2;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', _vm._b({}, 'v-card', _vm.props_card, false), [_c('v-card-text', {
    class: {
      'px-12 py-8': _vm.detect == 'pc'
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "lg": ""
    }
  }, [_c('div', {
    staticClass: "tit tit--xs"
  }, [_c('v-layout', _vm._b({
    staticStyle: {
      "gap": "16px"
    }
  }, 'v-layout', {
    'align-center': true,
    'justify-space-between': _vm.detect == 'mobile'
  }, false), [_c('span', [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(_vm._s((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.name))]), _c('span', [_vm._v("님 반갑습니다")])])])], 1)]), _c('v-col', {
    attrs: {
      "cols": "12",
      "lg": "auto"
    }
  }, [_c('v-layout', _vm._b({}, 'v-layout', {
    'align-center': true,
    'justify-end': _vm.detect == 'pc',
    'justify-space-between': _vm.detect == 'mobile'
  }, false), [_c('span', [_vm._v(" 보증금 ")]), _c('v-btn', {
    staticClass: "cash-btn mr-n3",
    class: {
      'my-n1': _vm.detect == 'pc'
    },
    attrs: {
      "text": "",
      "min-width": "auto",
      "to": "/mypage/cashes/inquiry"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": ""
    }
  }, [_c('b', {
    staticClass: "primary--text"
  }, [_vm._v(" " + _vm._s((_ref = ((_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : _vm$user2.deposit) || 0) === null || _ref === void 0 ? void 0 : (_ref$format = _ref.format) === null || _ref$format === void 0 ? void 0 : _ref$format.call(_ref)) + " ")]), _c('span', [_vm._v("원")])])], 1)], 1)], 1)], 1), _c('kcb-cert', {
    ref: "kcbCert"
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }